export const romanianTranslations = {
    enterPatientID: "Introduceți ID-ul pacientului",
    info: "Info",
    info1: "Bună dragă prietene.",
    info2: "Bine ați venit la minunata aplicație care este această frumusețe. A fost dezvoltat de băieții fantastici de la Fishy Funksticks. Aici este partea de jos:",
    info3: "Puteți apăsa un buton pe ecranul de pornire pentru a adăuga cererea dvs. la sistem. Apoi decidem cât de important este și, în cele din urmă, îl dăm uneia dintre drăgălașii noștri asistente care va veni și vă va oferi tot ajutorul de care aveți nevoie. Puteți adăuga informații despre dvs. în meniul de opțiuni, precum și puteți schimba modul în care arată, simte și miroase site-ul.",
    info4:  "Dar da, cam asta e. Pace afară.",
  
    LanguagePref:  "Limba preferată...",
  
    logout:  "deconectare",
  
    nurse:  "ASISTENT MEDICAL",
    patient:  "RABDATOR",
    iama: "Sunt un...",
    submit: "TRIMITE",
  
    username:  "Introduceti numele de utilizator:",
    password:  "Introdu parola:",
    invalidcred: "Acreditări nevalide, încercați din nou!",
    invalidval: "Vă rugăm să introduceți valori valide.",
  
    patientid:  "ID pacient", 
    requesttype:  "Tipul cererii", 
    extrainfo: "Informații suplimentare",
    done:  "Marcați ca gata",
  
    yournexttask:  "Următoarea ta sarcină",
    break:  "Pauză",
    schedulebreak:  "Programați pauză",
  
    timeblockedout:  "La ce oră vrei să blochezi?",
    leave:  "Părăsi:",
    return:  "Întoarcere:",
  
    neurodiverse:  "Neurodiverse",
    nonverbal:  "Nonverbal",
    ESL:  "Engleza ca a doua limba",
    other:  "Alte",
    dark:  "ÎNTUNERIC",
    light:  "UȘOARĂ",
    options:  "Opțiuni",
    Iam:  "Eu sunt...",
  
    food:  "Ia mâncare",
    water:  "Ia apa",
    toilet :  "Du-te la toaletă",
    meds:  "La medicamente",
    assist:  "Asistență fizică",
    emergency:  "De urgență",
    settings:  "Setări",
    infoicon:  "Info",
  
    extrainfo:  "Doriți să adăugați informații suplimentare?",
    sendrequest:  "Trimite cerere",
    adddeets:  "Adaugă mai multe detalii aici",
  };
  